const MALE = 'M';
const FEMALE = 'F';
const UNKNOWN = 'U';
const MALE_DESCRIPTION = 'Male';
const FEMALE_DESCRIPTION = 'Female';
const UNKNOWN_DESCRIPTION = 'Unknown';

const genderMapping = {
    [MALE]: MALE_DESCRIPTION,
    [FEMALE]: FEMALE_DESCRIPTION,
    [UNKNOWN]: UNKNOWN_DESCRIPTION
};

export {
    MALE,
    MALE_DESCRIPTION,
    FEMALE,
    FEMALE_DESCRIPTION,
    UNKNOWN,
    UNKNOWN_DESCRIPTION,
    genderMapping
}